import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatMoney } from 'utils/helpers';
import { AccountingInvolvedParty } from 'v2-types/order';

const InvolvedPartyAccounted = ({ row, handleDeleteLink }: { row: AccountingInvolvedParty, handleDeleteLink: (paymentRecordId: string, associationKind: string, associationId: string) => void }) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column">
      {(row?.accounted_by && row?.accounted_by.length > 0)
        ? row?.accounted_by.map((accouted) => (

          <Box display="flex" flexDirection="column" style={{ marginBottom: 8 }} key={`${accouted.amount}${accouted.record.description}`}>
            <Box display="flex" flexDirection="row">
              <IconButton
                style={{ padding: 0, fontSize: 16, marginRight: 8 }}
                onClick={() => {
                  handleDeleteLink(accouted.record._id, row.kind, row._id);
                }}
                size="large"
              >
                <FontAwesomeIcon icon="trash" size="sm" />
              </IconButton>
              {accouted.record.description}
            </Box>
            <Box style={{ marginLeft: 16 }}>
              {`${formatMoney(accouted.amount)}`}
            </Box>
          </Box>

        ))
        : <>{t('common:notDefinedYet')}</>}
    </Box>
  );
};

export default InvolvedPartyAccounted;
